import { MessageReply } from '../use-chat.types';

const getConfidence = (reply: MessageReply): number =>
  reply.data.confidence ?? 0;

export const sortReplies = (replies: MessageReply[]) =>
  replies.sort((a, b) => getConfidence(b) - getConfidence(a));
